import RequestFreespin from "slotworks/state-machine/standard/states/request-freespin";
import { UnlockSymbols } from "commands/symbols-commands";
import Components from "slotworks/components/components";

export default class G288RequestFreespin extends RequestFreespin {

    public onEnter(cascadeSkip?: boolean) {
        UnlockSymbols(Components.matrix.getGridSymbols());
        super.onEnter(cascadeSkip);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/request-freespin.ts